import { Box, Typography } from '@mui/material';
import EnhancedTable from 'lib/designSystem/Table';
import React from 'react';

interface DocumentData {
  folio: string;
  operationId: string;
  amount: number;
  amountConciliated: number;
  documentRemainingAmountNet: number;
  arrearAmount: number;
  totalRemainingNet: number;
  issuedDate: string;
  paymentDate: string;
  arrearTrench?: string;
  arrearDays?: number;
  paidAt?: string;
}

interface CreditTablesProps {
  data: {
    onDateDocuments: DocumentData[];
    inArrearDocuments: DocumentData[];
    paidDocuments: DocumentData[];
  };
}

const CreditTables = (props: CreditTablesProps) => {
  const { data } = props;
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
        Documentos vigentes
      </Typography>
      <EnhancedTable
        data={data.onDateDocuments}
        dataHeaders={[
          { key: 'folio', label: 'Folio' },
          { key: 'operationId', label: 'Solicitud', type: 'numeric-id' },
          { key: 'amount', label: 'Monto', type: 'money' },
          {
            key: 'amountConciliated',
            label: 'Conciliado',
            type: 'money',
          },
          {
            key: 'documentRemainingAmountNet',
            label: 'Adeudado Doc',
            type: 'money',
          },
          {
            key: 'arrearAmount',
            label: 'Mora',
            type: 'money',
          },
          {
            key: 'totalRemainingNet',
            label: 'Adeudado total',
            type: 'invoice-remaining-amount',
          },
          { key: 'issuedDate', label: 'Emisión', type: 'date' },
          { key: 'paymentDate', label: 'Vencimiento', type: 'date' },
        ]}
        exportToFile="xlsx"
      />
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
        Documentos en mora
      </Typography>
      <EnhancedTable
        data={data.inArrearDocuments}
        dataHeaders={[
          { key: 'folio', label: 'Folio' },
          { key: 'operationId', label: 'Solicitud', type: 'numeric-id' },
          { key: 'amount', label: 'Monto', type: 'money' },
          {
            key: 'amountConciliated',
            label: 'Conciliado',
            type: 'money',
          },
          {
            key: 'documentRemainingAmountNet',
            label: 'Adeudado Doc',
            type: 'money',
          },
          {
            key: 'arrearAmount',
            label: 'Mora',
            type: 'money',
          },
          {
            key: 'totalRemainingNet',
            label: 'Adeudado total',
            type: 'invoice-remaining-amount',
          },
          { key: 'issuedDate', label: 'Emisión', type: 'date' },
          { key: 'paymentDate', label: 'Vencimiento', type: 'date' },
          {
            key: 'arrearTrench',
            label: 'Tramo de mora',
            type: 'arrear-trench',
          },
          {
            key: 'arrearDays',
            label: 'Días de mora',
          },
        ]}
        exportToFile="xlsx"
      />
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
        Documentos pagados (histórico)
      </Typography>
      <EnhancedTable
        data={data.paidDocuments}
        dataHeaders={[
          { key: 'folio', label: 'Folio' },
          { key: 'operationId', label: 'Solicitud', type: 'numeric-id' },
          { key: 'amount', label: 'Monto', type: 'money' },
          { key: 'issuedDate', label: 'Emisión', type: 'date' },
          { key: 'paymentDate', label: 'Vencimiento', type: 'date' },
          { key: 'paidAt', label: 'Fecha pago', type: 'date' },
        ]}
        exportToFile="xlsx"
      />
    </Box>
  );
};

export default CreditTables;
